import { Grow, Modal } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux'
import cholaLogo from '../Images/cholamandalam-logo.png'

function Loader() {
    const { message } = useSelector((state) => state.mandateInfo);
    return (
        <Modal open={true} aria-labelledby="modal-title" keepMounted>
            <Grow in={true} style={{ transformOrigin: "0 50 50" }} timeout={500}>
                <div
                    className="modal fade show"
                    id="Terms"
                    style={{ display: "block" }}
                    aria-modal={true}
                >
                    <div className="modalPageCent">
                        <div className="col-12">
                            <div className="row">
                                <div className="col-12">
                                    <div className="text-center">
                                        <img src={cholaLogo} alt='Chola' className="img-fluid logo-rotate" />
                                    </div>
                                    {message && <div className="text-center">
                                        Redirecting you to third party URL</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Grow>
        </Modal>
    )
}

export default Loader